import * as React from 'react';
import {
    OverlayContainer,
    CloseButton
} from 'components';
import {
    actions as overlayWindowsActions,
    GenericOverlayOperation
} from 'services/overlay-windows/overlay-windows-service';
import { IState } from 'services/root-reducer';
import { getOperationSafe } from 'selectors';
import { connect } from 'react-redux';
import { OverlayMessage } from 'scenes/overlay-message';
import { EOperationStatus, IOperation } from 'types';
import { WithTranslation, withTranslation } from 'react-i18next';
import { DataUpdateForm } from './data-update-form';

import './style.scss';

export interface IOverlayDataUpdateProps extends WithTranslation {
    updateDataOverlay: GenericOverlayOperation;
    submitDataOverlay: IOperation;
}
export interface IOverlayDataUpdateState {
    showSubmitSuccess: boolean;
}

const mapStateToProps = (state: IState) => ({
    updateDataOverlay: getOperationSafe(state, 'UPDATE_DATA_OVERLAY'),
    submitDataOverlay: getOperationSafe(state, 'SUBMIT_DATA_UPDATE_OVERLAY')
});

class OverlayDataUpdateComponent extends React.Component<IOverlayDataUpdateProps, IOverlayDataUpdateState> {
    constructor(props: IOverlayDataUpdateProps) {
        super(props);

        this.state = this.getInitialState();

        this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    }

    getInitialState(): Readonly<IOverlayDataUpdateState> {
        return {
            showSubmitSuccess: false
        };
    }

    componentDidUpdate(
        prev_props: IOverlayDataUpdateProps,
        prev_state: IOverlayDataUpdateState
    ) {
        let {
            submitDataOverlay: oldSubmitDataOverlay
        } = prev_props;

        let {
            submitDataOverlay
        } = this.props;

        if (
            submitDataOverlay.status === EOperationStatus.SUCCESS
            && submitDataOverlay.status !== oldSubmitDataOverlay.status
        ) {
            /* eslint-disable-next-line */
            this.setState({
                showSubmitSuccess: true
            });
        }
    }

    onCloseButtonClick() {
        overlayWindowsActions.hideUpdateDataOverlay();
        this.setState(this.getInitialState());
    }

    render() {
        let { updateDataOverlay, t } = this.props;

        if (!updateDataOverlay.data?.visible) {
            return null;
        }

        return (
            <React.Fragment>
                <OverlayContainer
                    className='data-update-overlay'
                    containerClassname='form-wrapper'
                    backgroundOpacity={9}
                >
                    <CloseButton
                        onClick={this.onCloseButtonClick}
                    />

                    <DataUpdateForm onSubmit={(payload) => {
                        overlayWindowsActions.submitDataUpdateForm(payload);
                    }}
                    />
                </OverlayContainer>

                { this.state.showSubmitSuccess && (
                    <OverlayMessage
                        messageText={t('Сообщение отправлено')}
                        onCloseButtonClick={this.onCloseButtonClick}
                    />
                ) }
            </React.Fragment>
        );
    }
}

export const OverlayDataUpdate = withTranslation()(connect(mapStateToProps)(OverlayDataUpdateComponent));
